import './main.css'
import '../App.css'
import { useCallback, useEffect, useState } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBarcode, faMap } from "@fortawesome/free-solid-svg-icons";
import MessageModal from '../Pages/messageModal';
import { ChevronLeft, Trash2, X, ShoppingBag, Tickets, MapPin, Info } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { changeNum, changeUnits } from './common/function';
import { changeAlramModal, checkDuplicateLogins } from '../store';
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from 'react-router-dom';

function CouponDetail() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    // URL 파라미터 예시 (couponId)를 받고 싶다면 useParams 사용
    const { couponId } = useParams();

    // navigate의 state로 전달된 쿠폰 정보
    const location = useLocation();
    const coupon = location.state?.coupon;
    // 만약 쿠폰 정보가 없으면 에러처리 or 로딩처리
    // console.log("상세 쿠폰:", coupon);

    const JWT = useSelector((state) => state.JWT.value);

    // 탭, 안내박스 등 상태
    const [activeTab, setActiveTab] = useState(0);
    const [textBox, setTextBox] = useState(true);
    const [noticeBox, setNoticeBox] = useState(false);

    // Redux에 있는 전역 메시지를 쓰거나,
    // 혹은 이 컴포넌트 내에서만 알림 메시지를 관리해도 됩니다.
    const [message, setMessage] = useState("");

    // 날짜 포맷 (간단히 예시)
    const formatDateTime = (isoString) => {
        if (!isoString) return '';
        const date = new Date(isoString);
        const kst = new Date(date.getTime() + 9 * 60 * 60 * 1000);
        const year = kst.getFullYear();
        const month = String(kst.getMonth() + 1).padStart(2, '0');
        const day = String(kst.getDate()).padStart(2, '0');
        const hours = String(kst.getHours()).padStart(2, '0');
        const minutes = String(kst.getMinutes()).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}`;
    };

    // 뒤로가기
    const onBack = () => {
        navigate(-1);
    };

    const onDelete = async () => {
        await axios.post(process.env.REACT_APP_API + '/api/exchange-events/coupon/user/remove', {
            coupon_no: coupon.no
        }, {
            headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            console.log(tmp)
            if (tmp?.success) {
                setMessage({ "code": 0, "msg": tmp?.message ?? "Success" })
                dispatch(changeAlramModal())
                onBack()
            }
            else {
                setMessage({ "code": 1, "msg": tmp?.message ?? "Fail" })
                dispatch(changeAlramModal())
            }
        }).catch((error) => {
            if (error?.status === 999) {
                dispatch(checkDuplicateLogins(true))
            }
            else {
                console.log(error)
            }
        })
    };

    const handleDelete = () => {
        if (window.confirm(t('coupons_4'))) {
            onDelete();
        }
    };

    // 예시: 지도로 이동하기
    const handleClickMap = () => {
        const brand = encodeURIComponent(coupon.ci_brand_name);
        const url = `https://m.place.naver.com/restaurant/list?query=${brand}`;

        if (window.Telegram?.WebApp?.openLink) {
            // 텔레그램 미니앱
            window.Telegram.WebApp.openLink(url);
        } else {
            // 일반 브라우저
            window.open(url, '_blank');
        }
    };

    // 쿠폰이 없으면 로딩 or 에러
    if (!coupon) {
        return (
            <div style={{ padding: "20px" }}>
                {t('coupons_34') /* "쿠폰 정보가 없습니다" 등 */}
            </div>
        );
    }

    return (
        <div
            className="friend"
            style={{
                background: "#f5f5f5",
                padding: "0px",
                position: "relative"
            }}
        >
            <div style={{ padding: '0px', paddingBottom: '70px', fontFamily: 'sans-serif' }}>
                <MessageModal message={message} />
                {/* 고정된 상단 헤더 */}
                <div
                    style={{
                        position: 'fixed',
                        top: "0px",
                        left: "0px",
                        width: "100%",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: "50px",
                        background: "#fff",
                        padding: "0 15px",
                        zIndex: "10",
                        borderBottom: "1px solid #dddddd"
                    }}
                >
                    {/* 뒤로가기 버튼 */}
                    <div
                        style={{
                            color: '#000',
                            cursor: 'pointer',
                            position: 'absolute',
                            left: '15px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            display: 'flex',
                            alignItems: 'center',
                        }}
                        onClick={() => {
                            window.scrollTo({ top: 0, left: 0 });
                            onBack();
                        }}
                    >
                        <ChevronLeft style={{ width: '24px', height: '24px' }} />
                        <ShoppingBag style={{ width: '20px', height: '20px', marginLeft: "15px" }} />
                    </div>

                    {/* 중앙 타이틀 */}
                    <div style={{ fontWeight: 'bold', color: "#000" }}>
                        {t('coupons_5')}
                    </div>

                    {/* 우측 아이콘 (사용완료/사용불가만 삭제 아이콘, 아니면 닫기) */}
                    {coupon.uc_pin_status_cd !== '01' ? (
                        <div
                            style={{
                                color: '#000',
                                cursor: 'pointer',
                                position: 'absolute',
                                right: '15px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                display: 'flex',
                                alignItems: 'center',
                            }}
                            onClick={handleDelete}
                        >
                            <Trash2 style={{ width: '20px', height: '20px' }} />
                        </div>
                    ) : (
                        <div
                            style={{
                                color: '#000',
                                cursor: 'pointer',
                                position: 'absolute',
                                right: '15px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                display: 'flex',
                                alignItems: 'center',
                            }}
                            onClick={() => {
                                window.scrollTo({ top: 0, left: 0 });
                                onBack();
                            }}
                        >
                            <X style={{ width: '24px', height: '24px' }} />
                        </div>
                    )}
                </div>

                <div
                    style={{
                        color: "#000",
                        textAlign: "left",
                        padding: "15px 15px",
                        display: "flex",
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        marginTop: "50px"
                    }}
                >
                    <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
                        <div
                            style={{
                                padding: "5px",
                                borderRadius: "12px",
                                width: "35px",
                                height: "35px",
                                background: "#fff"
                            }}
                        >
                            <img src='/img/saycoin.png' style={{ width: "100%" }} />
                        </div>
                        <div style={{ fontWeight: "bold" }}>
                            Saypot의 이벤트 선물
                        </div>
                    </div>
                    <div
                        style={{
                            padding: "5px 15px",
                            border: "1px solid #e5e5e5",
                            borderRadius: "30px",
                            background: "#fff",
                            fontSize: '12px',
                            cursor: "pointer"
                        }}
                        onClick={() => alert("Coming Soon")}
                    >
                        쿠폰추억
                    </div>
                </div>

                {/* 쿠폰 이미지 영역 */}
                <div
                    style={{
                        width: '100%',
                        textAlign: 'center',
                        marginBottom: '15px',
                        position: 'relative',
                        padding: "0 15px",
                    }}
                >
                    <img
                        src={coupon.uc_coupon_img_url}
                        alt="img"
                        style={{
                            width: '100%',
                            borderRadius: '8px',
                            opacity: coupon.uc_pin_status_cd !== '01' ? '0.6' : '1',
                            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)"
                        }}
                    />

                    {/* 사용완료 / 사용불가 도장 이미지 */}
                    {coupon.uc_pin_status_cd !== '01' && (
                        <div
                            style={{
                                position: 'absolute',
                                top: '0px',
                                right: '15px',
                            }}
                        >
                            <img
                                src={
                                    coupon.uc_pin_status_cd === '03'
                                        ? '/newImg/unavailable.png'
                                        : '/newImg/complete.png'
                                }
                                alt={coupon.usedType}
                                style={{ width: '100px' }}
                            />
                        </div>
                    )}
                </div>

                {/* 탭 영역 */}
                <div style={{ background: "#fff", padding: "15px 0 10px", marginBottom: "8px" }}>
                    <div
                        style={{
                            display: 'flex',
                            borderBottom: '1px solid #ddd',
                            color: "#000",
                            justifyContent: "space-around"
                        }}
                    >
                        <div
                            onClick={() => setActiveTab(0)}
                            style={{
                                textAlign: 'center',
                                padding: '0 0 15px',
                                cursor: 'pointer',
                                fontWeight: activeTab === 0 ? 'bold' : 'normal',
                                borderBottom:
                                    activeTab === 0 ? '2px solid #000' : '2px solid transparent',
                            }}
                        >
                            {t('coupons_6')}
                        </div>
                        <div
                            onClick={() => alert("Coming Soon")}
                            style={{
                                textAlign: 'center',
                                padding: '0 0 15px',
                                cursor: 'pointer',
                                fontWeight: activeTab === 1 ? 'bold' : 'normal',
                                borderBottom:
                                    activeTab === 1 ? '2px solid #000' : '2px solid transparent',
                            }}
                        >
                            {t('coupons_7')}
                        </div>
                    </div>
                    <div style={{ padding: '0 15px' }}>
                        {coupon.uc_pin_status_cd === '01' && (
                            <>
                                <div
                                    style={{
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                        padding: "15px 0",
                                        color: "#000",
                                        textAlign: "left"
                                    }}
                                >
                                    {t('coupons_12')}
                                </div>
                                <div
                                    style={{
                                        border: '1px solid #f3f3f3',
                                        borderRadius: '5px',
                                        padding: '15px',
                                        backgroundColor: '#fafafa',
                                        marginBottom: '10px',
                                    }}
                                >
                                    <div
                                        style={{
                                            fontWeight: 'bold',
                                            color: '#000',
                                            fontSize: '14px',
                                            textAlign: "left",
                                            marginBottom: "15px"
                                        }}
                                    >
                                        {t('coupons_8')}
                                    </div>
                                    <div
                                        style={{
                                            display: "flex",
                                            gap: "10px",
                                            alignItems: "center"
                                        }}
                                    >
                                        <div
                                            style={{
                                                background: "#5492ff",
                                                borderRadius: "10px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center"
                                            }}
                                        >
                                            <FontAwesomeIcon
                                                icon={faBarcode}
                                                style={{
                                                    padding: "8px",
                                                    fontSize: "20px"
                                                }}
                                            />
                                        </div>
                                        <div
                                            style={{
                                                color: "#7d7d7d",
                                                fontSize: "14px",
                                                textAlign: "left",
                                                fontWeight: "500"
                                            }}
                                        >
                                            {t('coupons_15_0')} <br />
                                            {t('coupons_15_1')}
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>

                {/* 탭 컨텐츠 */}
                {activeTab === 0 ? (
                    // [선물정보]
                    <>
                        <div
                            style={{
                                padding: "15px",
                                background: "#fff",
                                marginBottom: "8px"
                            }}
                        >
                            <div
                                style={{
                                    fontSize: "16px",
                                    fontWeight: "bold",
                                    padding: "5px 0px 10px",
                                    color: "#000",
                                    textAlign: "left"
                                }}
                            >
                                {t('coupons_13')}
                            </div>
                            <div style={{ borderRadius: '8px' }}>
                                <div
                                    style={{
                                        display: 'flex',
                                        fontSize: '14px',
                                        padding: '10px',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        background: "#f5f5f5",
                                        borderRadius: "5px"
                                    }}
                                >
                                    <div style={{ color: '#000' }}>
                                        {t('coupons_16')}
                                    </div>
                                    <div style={{ color: '#5492ff', fontWeight: "bold" }}>
                                        {changeNum(coupon.ci_real_price)}원
                                    </div>
                                </div>
                                <RowItem
                                    label={t('coupons_9')}
                                    value={coupon.uc_expire_date.split(' ')[0]}
                                />
                                <RowItem
                                    label={t('coupons_17')}
                                    value={coupon.bc_order_no}
                                />
                                <RowItem
                                    label={t('coupons_18')}
                                    value={coupon.ci_brand_name}
                                />
                                {/* ▼ 여기서 "주문일"을 "년-월-일 시:분:초"로 표시 */}
                                <RowItem
                                    label={t('coupons_10')}
                                    value={formatDateTime(coupon.uc_exchange_time)}
                                />
                                <RowItem
                                    label={t('coupons_11')}
                                    value={
                                        coupon.uc_pin_status_cd === '01'
                                            ? t('coupons_24')
                                            : coupon.uc_pin_status_cd === '02'
                                                ? t('coupons_25')
                                                : t('coupons_26')
                                    }
                                />
                                <RowItem
                                    label={t('coupons_19')}
                                    value={t('coupons_21')}
                                />
                                <RowItem
                                    label={t('coupons_20')}
                                    value={t('coupons_21')}
                                />
                            </div>
                        </div>



                        <div
                            style={{
                                padding: "12px 15px",
                                background: "#fff",
                                marginBottom: "8px"
                            }}
                        >
                            <div
                                style={{
                                    fontSize: "16px",
                                    fontWeight: "bold",
                                    padding: "5px 0px",
                                    color: "#000",
                                    textAlign: "left"
                                }}
                            >
                                {t('coupons_14')}
                            </div>
                            <div style={{ width: "100%", padding: "5px 0", display: "flex", alignItems: 'flex-start', justifyContent: "space-between", marginBottom: "3px" }}>
                                <div style={{ display: "flex", alignItems: 'center', gap: "10px" }}>
                                    <div style={{ color: '#5492ff', display: "flex", alignItems: 'center', justifyContent: "center" }}><Tickets size={20} /></div>
                                    <div style={{ fontSize: "14px", color: "#000" }}>{t('coupons_27')}</div>
                                </div>
                                <div></div>
                            </div>
                            <div style={{ width: "100%", padding: "5px 0", display: "flex", alignItems: 'flex-start', justifyContent: "space-between", position: "relative" }}>
                                <div style={{ display: "flex", alignItems: 'center', gap: "10px" }}>
                                    <div style={{ color: '#5492ff', display: "flex", alignItems: 'center', justifyContent: "center" }}><MapPin size={20} /></div>
                                    <div style={{ fontSize: "14px", color: "#000", display: "flex", alignItems: "center" }}>
                                        {t('coupons_28')}
                                        <Info size={14} style={{ color: "gray", marginLeft: "3px", cursor: "pointer" }} onClick={() => setNoticeBox(true)} />
                                    </div>
                                </div>
                                <div
                                    style={{ background: "#f9f9f9", border: "1px solid #ebebeb", padding: "5px 10px", fontSize: "12px", display: "flex", alignItems: 'center', justifyContent: "center", color: "#757575", fontWeight: "500", cursor: "pointer" }}
                                    onClick={handleClickMap}>
                                    <div style={{ marginRight: "2px", color: "gray" }}><i className="fa-regular fa-map"></i></div>
                                    <div>{t('coupons_29')}</div>
                                </div>
                                {textBox && (
                                    <div style={{ position: "absolute", right: "0", bottom: "30px", color: "#ddd" }}>
                                        <img src='/newImg/textbox.png' style={{ width: "205px" }} />
                                        <X style={{ width: '22px', height: '22px', position: "absolute", right: "5px", top: '5px', color: "#9d9d9d", cursor: "pointer", zIndex: "1" }} onClick={() => setTextBox(false)} />
                                        <div style={{ position: "absolute", top: "45%", left: "50%", transform: 'translate(-50%, -55%)', fontSize: "13px", width: "100%" }}>
                                            {t('coupons_30_0')}<br />
                                            <span style={{ color: "#f3df35" }}>{t('coupons_30_1')}</span>{t('coupons_30_2')}
                                        </div>
                                    </div>
                                )}
                                {noticeBox && (
                                    <div style={{ position: "absolute", right: "0", bottom: "34px", width: "93%", background: "#fff", border: "1px solid #a5a5a5", padding: "15px", textAlign: "left", color: "#676767", zIndex: "2" }}>
                                        <X style={{ width: '22px', height: '22px', position: "absolute", right: "10px", top: '10px', color: "#9d9d9d", cursor: "pointer", zIndex: "3" }} onClick={() => setNoticeBox(false)} />
                                        <div style={{ fontSize: "13px", width: "100%", fontWeight: "bold", color: "#000" }}>{t('coupons_31')}</div>
                                        {
                                            coupon?.ci_available_store
                                                ?
                                                <>
                                                    <div style={{ fontSize: "11px", width: "100%", fontWeight: "500", marginTop: "10px" }}>{t('coupons_32')}</div>
                                                    <div style={{ fontSize: "11px", width: "100%", whiteSpace: 'pre-wrap' }}>{coupon.ci_available_store}</div>
                                                </>
                                                :
                                                ""
                                        }
                                        {
                                            coupon?.ci_unavailable_store
                                                ?
                                                <>
                                                    <div style={{ fontSize: "11px", width: "100%", fontWeight: "500", marginTop: "10px" }}>{t('coupons_33')}</div>
                                                    <div style={{ fontSize: "11px", width: "100%", whiteSpace: 'pre-wrap' }}>{coupon.ci_unavailable_store}</div>
                                                </>
                                                :
                                                ""
                                        }
                                    </div>
                                )}
                            </div>
                        </div>

                        <div
                            style={{
                                padding: "30px 15px",
                                background: "#fff",
                                marginBottom: "50px"
                            }}
                        >
                            <div
                                style={{
                                    fontSize: '13px',
                                    lineHeight: '1.5',
                                    whiteSpace: 'pre-wrap',
                                    textAlign: 'left',
                                    color: "#000"
                                }}
                            >
                                {coupon.ci_content}
                            </div>
                        </div>
                    </>
                ) : (
                    // [상품정보]
                    <div style={{ padding: '0 10px' }}>
                        <div
                            style={{
                                fontSize: '13px',
                                lineHeight: '1.5',
                                whiteSpace: 'pre-wrap',
                                textAlign: 'left',
                                color: "#000"
                            }}
                        >
                            {coupon.ci_content}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

function RowItem({ label, value }) {
    return (
        <div
            style={{
                display: 'flex',
                fontSize: '14px',
                padding: '14px 0',
                justifyContent: 'space-between',
                alignItems: 'center',
                borderBottom: "1px solid #f5f5f5"
            }}
        >
            <div style={{ color: '#8b8b8b' }}>{label}</div>
            <div style={{ color: '#000' }}>{value}</div>
        </div>
    );
}

export default CouponDetail;